import createMap, { highlightProject } from "./create-map.js";
import esriTopo from "./layers/esri_topo.json";
import esriHybrid from "./layers/esri_hybrid.json";
import counties from "./layers/counties.json";
import census from "./layers/census.json";
import drought from "./layers/drought.json";
import token from "./token.js";
import bbox from "@turf/bbox";

drought.token = token;

const BASEMAPS = [
        {
            name: "ESRI Topographic",
            data: esriTopo,
            active: true,
        },
        {
            name: "ESRI Imagery Hybrid",
            data: esriHybrid,
        },
    ],
    ICON_NAMES = [
        "Incubation_Active",
        "Incubation_Complete",
        "Innovation_Active",
        "Innovation_Complete",
        "Insight_Active",
        "Insight_Complete",
    ],
    ICONS = {
        highlight: [
            "SITE_ROOT/icons/highlight.png",
            "SITE_ROOT/icons/highlight@2x.png",
        ],
    },
    ICON_COLORS = ["match", ["get", "icon"]];

ICON_NAMES.forEach((name) => {
    ICONS[name] = [
        `SITE_ROOT/icons/${name}.png`,
        `SITE_ROOT/icons/${name}@2x.png`,
    ];
    ICON_COLORS.push(name);
    ICON_COLORS.push(
        name.startsWith("Incubation")
            ? "#5c97ac"
            : name.startsWith("Insight")
            ? "#abbd6c"
            : name.startsWith("Innovation")
            ? "#f15d22"
            : "#666"
    );
});
ICON_COLORS.push("#666");

async function getProjectData(id) {
    const response = await fetch(`SITE_ROOT/layers/${id}.geojson`),
        data = await response.json();
    return data;
}

const PROJECT_POINTS = {
    name: "Projects",
    description: null,
    type: "geojson",
    dataLayer: true,
    active: true,
    data: { type: "FeatureCollection", features: [] },
    layers: [
        {
            // https://maplibre.org/maplibre-gl-js-docs/style-spec/layers/#symbol
            id: "projects",
            type: "symbol",
            layout: {
                "icon-image": "{icon}",
                "icon-allow-overlap": true,
            },
        },
    ],
};

const PROJECT_HIGHLIGHT = {
    name: `${PROJECT_POINTS.name}_highlight`,
    description: null,
    type: "geojson",
    active: true,
    data: { type: "FeatureCollection", features: [] },
    layers: [
        {
            id: "project_highlight",
            type: "symbol",
            layout: {
                "icon-image": "highlight",
                "icon-allow-overlap": true,
                "icon-ignore-placement": true,
            },
        },
    ],
};

const PROJECT_POLYGONS = {
    name: `${PROJECT_POINTS.name}_polygon`,
    description: null,
    type: "geojson",
    active: true,
    data: { type: "FeatureCollection", features: [] },
    layers: [
        {
            id: "project_polygon_fill",
            type: "fill",
            paint: { "fill-color": ICON_COLORS, "fill-opacity": 0.5 },
        },
        {
            id: "project_polygon_line",
            type: "line",
            paint: { "line-color": ICON_COLORS, "line-width": 4 },
        },
    ],
};

window.project_map = window.project_map || {
    setProjectData(mapId, data) {
        data = {
            ...data,
            features: data.features.filter((feat) => Boolean(feat.geometry)),
        };
        this.data = data;
        this.projectOverlay = { ...PROJECT_POINTS, data };
        this.map = createMap(
            mapId,
            BASEMAPS,
            [
                drought,
                census,
                counties,
                PROJECT_POLYGONS,
                PROJECT_HIGHLIGHT,
                this.projectOverlay,
            ],
            ICONS
        );
    },
    zoomToProject(id) {
        const project = this.data.features.find((feature) => feature.id == id);
        if (!project) {
            return;
        }
        if (project["geometry-polygon"]) {
            this.map.fitBounds(bbox(project["geometry-polygon"]), {
                padding: 96,
            });
        } else if (project.geometry.type === "Point") {
            this.map.flyTo({ center: project.geometry.coordinates, zoom: 8 });
        } else if (project.geometry.type === "MultiPoint") {
            this.map.fitBounds(bbox(project.geometry), {
                padding: 96,
            });
        }
        highlightProject(this.projectOverlay, this.map, project);
    },
};
